<template>
  <div align="center" class="container">
    <!-- <v-card flat class="mb-4 text-left">
      <v-card-title class="primary text-white">Generate Device Summary</v-card-title>
      <v-card-text class="pa-10">
        <v-row class="pb-0">
          <v-col class="pb-0">
            <v-menu
              :max-height="500"
              :close-on-content-click="false"
              offset-y
              v-model="selectDeviceMenu"
              :max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="ml-2"
                  v-model="selectedDevicesNames"
                  label="Select devices"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-card :max-width="500">
                <v-card-title v-if="allDevices.length">
                  <v-spacer></v-spacer>
                  <v-btn
                    color
                    outlined
                    small
                    @click="selectAllDevices('select')"
                    v-if="selectedDevices.length !== allDevices.length"
                  >Select All</v-btn>
                  <v-btn
                    color
                    outlined
                    small
                    @click="selectAllDevices('unselect')"
                    v-else
                  >Unselect All</v-btn>
                </v-card-title>
                <v-card-text>
                  <v-list v-if="allDevices.length">
                    <v-list-item-group v-model="selectedDevices" multiple>
                      <template v-for="(item, i) in allDevices">
                        <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                        <v-list-item
                          v-else
                          :key="`item-${i}`"
                          :value="item"
                          active-class="success--text text--accent-4"
                        >
                          <template v-slot:default="{ active, toggle }">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-checkbox
                                :input-value="active"
                                :true-value="item"
                                color="success accent-4"
                                @click="toggle"
                              ></v-checkbox>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                  <v-list v-else>No devices</v-list>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="generateReport" class="mr-6" :disabled="!selectedDevices.length">Filter</v-btn>
          <v-btn color="success" text @click="exportCSV" :disabled="!allDevices.length">Export</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>-->
    <div v-if="summary.length">
      <v-card-title>
        Summary
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template #activator="{ on}">
            <v-btn color="blue" text v-on="on" @click="exportCSV">
              Export
              <v-icon small class="ml-2">description</v-icon>
            </v-btn>
          </template>
          <span>Export as csv file</span>
        </v-tooltip>
      </v-card-title>
      <v-pagination v-model="query.page" :length="pageCount" circle></v-pagination>
      <v-card flat>
        <v-card-text class="my-4">
          <v-data-table
            :headers="headers"
            :items="summary"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="query.limit"
            :page.sync="query.page"
            @page-count="pageCount = $event"
            hide-default-footer
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item,index) in items" :key="index">
                  <td class="text-left">{{item.device_uuid}}</td>
                  <td class="text-left">{{item.name}}</td>
                  <td class="text-left">{{item.status}}</td>
                  <td class="text-left">{{item.online ? 'Online': 'Offline'}}</td>
                  <td class="text-left">{{item.racks_enabled ? "Yes" : 'No'}}</td>
                  <td class="text-left">{{item.racks_configured ? "Yes" : 'No'}}</td>
                  <td class="text-left">{{item.campaigns.length}}</td>
                  <td class="text-left">
                    {{item.campaigns.find(campaign => campaign.published) ? item.campaigns.find(campaign => campaign.published).name
                    : '-'}}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-pagination v-if="summary.length > 20" v-model="query.page" :length="pageCount" circle></v-pagination>
    </div>
    <div v-else class="mt-5">
      No available summary
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
function initialState () {
  return {
    displayAll: false,
    model: [],
    selectDeviceMenu: false,
    endDateMenu: false,
    endDate: '',
    selectedDevices: [],
    selectDevicesError: false,
    headers: [
      { text: 'Device UUID', value: 'device_uuid' },
      { text: 'Name', value: 'name' },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Online', value: 'online', sortable: false },
      { text: 'Racks Enabled', value: 'racks_enabled', sortable: false },
      { text: 'Racks Configured', value: 'racks_configured', sortable: false },
      { text: 'Total Campaigns', value: 'total_campaigns', sortable: false },
      { text: 'Active Campaigns', value: 'active_campaign', sortable: false }
    ],
    allDevices: [],
    query: {
      page: 1,
      limit: 25
    },
    pageCount: 0
  }
}
export default {
  data () {
    return initialState()
  },
  computed: {
    selectedDevicesNames () {
      if (this.selectedDevices.length > 0) {
        return this.selectedDevices.map(el => el.name)
      }
      return ''
    },
    devices () {
      return this.allDevices.map(el => el.device_uuid)
    },
    ...mapGetters({
      summary: 'signage/devicesSummary',
      vg_allDevices: 'signage/allDevicesPagedWithLocations'
    })
  },
  async mounted () {
    this.spinner(true)
    const data = {
      device_uuids: []
    }
    let query = {
      limit: 100,
      page: 1,
      withLocations: false
    }
    try {
      await this.$store.dispatch('signage/GetDevicesReportSummary', data)
    } catch (e) {
      this.$store.commit('signage/SET_DEVICES_SUMMARY', '')
      this.snackbar({ text: e.response.data.msg })
    }
    try {
      await this.$store.dispatch(
        'signage/GetAllSignageDevicesPagedWithLocations',
        query
      )
      this.allDevices = this.vg_allDevices
      // for (let i = 1; i < this.vg_allDevices.total_pages; i++) {
      //   query.page = i + 1
      //   await this.$store.dispatch('signage/GetAllSignageDevicesPagedWithLocations', query)
      //   this.allDevices = [...this.allDevices, ...this.vg_allDevices.devices]
      // }
      this.displayAll = true
    } catch (e) {
      this.snackbar({ text: e.response.data.msg })
    }
    this.spinner(false)
  },
  methods: {
    selectAllDevices (condition) {
      if (condition === 'select') {
        this.selectedDevices = this.allDevices
      } else if (condition === 'unselect') {
        this.selectedDevices = []
      }
    },
    async generateReport () {
      if (this.selectedDevices.length !== 0) {
        this.spinner(true)
        const data = {
          device_uuids: this.selectedDevices.map(el => el.device_uuid)
        }
        try {
          await this.$store.dispatch('signage/GetDevicesReportSummary', data)
          // this.selectedDevices = []
          this.snackbar({ text: 'Device summaries retrieved' })
          this.spinner(false)
        } catch (e) {
          this.snackbar({ text: e.response.data.msg })
          this.spinner(false)
        }
      } else {
        this.snackbar({ text: 'Device not selected' })
      }
    },
    // Set up the data from the server in csv format
    async exportCSV () {
      // if (this.selectedDevices.length !== 0) {
      //   this.snackbar({ text: 'Exporting' })
      // } else {
      //   this.snackbar({ text: 'Exporting summary of all devices' })
      // }
      try {
        // let value = {
        //   device_uuids: this.selectedDevices.map(el => el.device_uuid)
        // }
        // await this.$store.dispatch('signage/GetDevicesReportSummary', value)

        // map according to  desired keys
        const data = this.summary.map(el => ({
          id: el.id,
          device_uuid: el.device_uuid,
          name: el.name,
          status: el.status,
          online: el.online,
          racks_enabled: el.racks_enabled,
          racks_configured: el.racks_configured,
          total_campaigns: el.campaigns.length,
          active_campaigns: el.campaigns.find(campaign => campaign.published)
            ? el.campaigns.find(campaign => campaign.published).name
            : ''
        }))
        const csvRows = []

        // get the headers
        const headers = Object.keys(data[0])
        csvRows.push(headers.join(','))

        // loop over the rows
        for (const row of data) {
          const values = headers.map(header => {
            const escaped = ('' + row[header]).replace(/"/g, '\\"')
            return `"${escaped}"`
          })
          csvRows.push(values.join(','))
        }
        const csv = csvRows.join('\r\n')
        this.download(csv)
        try {
          await this.$store.dispatch('signage/GetDevicesReportSummary')

          this.selectedDevices = []
        } catch (err) {
          this.snackbar({ text: err.response.data.msg })
        }
        this.spinner(false)
      } catch (e) {
        this.snackbar({ text: e.response.data.msg })
        this.spinner(false)
      }
    },

    // download csv
    download (data) {
      const blob = new Blob([data], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('hidden', '')
      a.setAttribute('href', url)
      a.setAttribute('download', `devices_summary.csv`)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    resetAll () {
      Object.assign(this.$data, initialState())
    }
  }
}
</script>

<style>
</style>
